import { api } from "./httpClient";
import { parseSpecialDays } from "../utils/rateTiers";

const KEY_WEEKEND_DAYS = "WeekendDays";
const KEY_CALENDAR = "SeasonCalendar";
const KEY_TIERS = "RoomTiers";

function parseJson(raw, fallback) {
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export const seasonService = {
  async load() {
    const settings = await api("/settings");
    return {
      weekendDays: String(settings?.[KEY_WEEKEND_DAYS] || ""),
      calendar: parseJson(settings?.[KEY_CALENDAR], {}),
      tiers: parseJson(settings?.[KEY_TIERS], {}),
      specialDays: parseSpecialDays(settings),
    };
  },

  async mutateJson(key, mutator) {
    const settings = await api("/settings");
    const current = parseJson(settings?.[key], {});
    const next = mutator({ ...current });
    await api("/settings", {
      method: "POST",
      body: JSON.stringify({ ...settings, [key]: JSON.stringify(next) }),
    });
  },

  async setWeekendDays(value) {
    const settings = await api("/settings");
    await api("/settings", {
      method: "POST",
      body: JSON.stringify({ ...settings, [KEY_WEEKEND_DAYS]: String(value || "") }),
    });
  },

  savePropertyCalendar(propertyName, entry) {
    return this.mutateJson(KEY_CALENDAR, (calendar) => {
      calendar[propertyName] = entry;
      return calendar;
    });
  },

  saveRoomTier(key, tier) {
    return this.mutateJson(KEY_TIERS, (tiers) => {
      tiers[key] = tier;
      return tiers;
    });
  },
};
